module.exports = __webpack_public_path__ + "files/crewchief.341c1a566a9c850f2d598579686eeb41.gif";